import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrocarEmpresaService {

  public subject = new Subject<any>();

  constructor(private readonly http: HttpClient) {
  }

  public getAllEmpresas(idEmpresa) {
    return this.http.get(`/apiconnect/importation/company/group-company/${idEmpresa}/companies?tipOrdernamento=nomeAsc`);
  }

  public getCompaniesByUser() {
    return this.http.get(`/apiconnect/company-data/me/companies`);
  }

}
